import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { LeaveRequest } from './leave-request.model';

export const loadLeaveRequests = createAction(
    '[LeaveRequest/API] Load LeaveRequests',
    props<{ leaveRequests: LeaveRequest[] }>()
);

export const addLeaveRequest = createAction(
    '[LeaveRequest/API] Add LeaveRequest',
    props<{ leaveRequest: LeaveRequest }>()
);

export const upsertLeaveRequest = createAction(
    '[LeaveRequest/API] Upsert LeaveRequest',
    props<{ leaveRequest: LeaveRequest }>()
);

export const addLeaveRequests = createAction(
    '[LeaveRequest/API] Add LeaveRequests',
    props<{ leaveRequests: LeaveRequest[] }>()
);

export const upsertLeaveRequests = createAction(
    '[LeaveRequest/API] Upsert LeaveRequests',
    props<{ leaveRequests: LeaveRequest[] }>()
);

export const updateLeaveRequest = createAction(
    '[LeaveRequest/API] Update LeaveRequest',
    props<{ leaveRequest: Update<LeaveRequest> }>()
);

export const updateLeaveRequests = createAction(
    '[LeaveRequest/API] Update LeaveRequests',
    props<{ leaveRequests: Update<LeaveRequest>[] }>()
);

export const deleteLeaveRequest = createAction(
    '[LeaveRequest/API] Delete LeaveRequest',
    props<{ id: number }>()
);

export const deleteLeaveRequestSuccess = createAction(
    '[LeaveRequest/API] Delete LeaveRequest',
    props<{ id: number }>()
);

export const deleteLeaveRequests = createAction(
    '[LeaveRequest/API] Delete LeaveRequests',
    props<{ ids: number[] }>()
);

export const deleteLeaveRequestsSuccess = createAction(
    '[LeaveRequest/API] Delete LeaveRequests Success',
    props<{ ids: number[] }>()
);

export const clearLeaveRequests = createAction(
    '[LeaveRequest/API] Clear LeaveRequests'
);

export const getLeaveRequests = createAction(
    '[LeaveRequest/API] Get LeaveRequests',
    props<{
        userId: string;
        userRole: number;
        startDate?: Date;
        endDate?: Date;
    }>()
);

export const putLeaveRequests = createAction(
    '[LeaveRequest/API] Put LeaveReqeusts',
    props<{ requests: Array<LeaveRequest> }>()
);
